"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useESignInterstitial = void 0;
const useESignInterstitialBase_hook_1 = require("./useESignInterstitialBase.hook");
const useESignInterstitial = ({ eSignData }) => {
    return (0, useESignInterstitialBase_hook_1.useESignInterstitialBase)({ eSignData });
};
exports.useESignInterstitial = useESignInterstitial;
//# sourceMappingURL=useESignInterstitial.hook.js.map